import React, { Component } from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import 'antd/dist/antd.min.css'
import './App.css';

import { firebaseAuth } from './constants'

import Login from './Login';
import Dashboard from './Dashboard';

function PrivateRoute ({component: Component, authed, ...rest}) {
    return (
      <Route
        {...rest}
        render={(props) => authed === true
          ? <Component {...props} />
          : <Redirect to={{pathname: '/login', state: {from: props.location}}} />}
      />
    )
  }
  
  function PublicRoute ({component: Component, authed, ...rest}) {
    return (
      <Route
        {...rest}
        render={(props) => authed === false
          ? <Component {...props} />
          : <Redirect to='/dashboard' />}
      />
    )
  }

class App extends React.Component {
    state = {
        authed: false
    }

    componentDidMount () {
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            if (user) {
            this.setState({
                authed: true,
                loading: false,
            })
            } else {
            this.setState({
                authed: false,
                loading: false
            })
            }
        })
    }
    
    componentWillUnmount () {
        this.removeListener()
    }
    
    render() {
        return(
            <BrowserRouter>
                <Switch>
                    <PrivateRoute authed={this.state.authed} path='/dashboard' component={Dashboard} />
                    <PublicRoute authed={this.state.authed} path='' component={Login} />
                </Switch>
            </BrowserRouter>
            
        )
    }
}


export default App


// WEBPACK FOOTER //
// ./src/App.js